import {
  ResourceStatsFragmentDoc,
  VisibleResourcesFragmentDoc,
  PrivateResourcesFragmentDoc
} from "@pathwright/graphql-client/src/generated"
import withLauncher from "@pathwright/ui/src/components/launcher/withLauncher"
import { usePathwrightContext } from "../pathwright/PathwrightContext"
import LibraryPreview from "./LibraryPreview"
import Place from "./Place"

const PlaceLauncher = withLauncher({
  Component: Place,
  Preload: window.LazyLibraryRoutes
})

const LibraryPlace = ({
  visibleResources,
  privateResources,
  resourceStats,
  onLaunch
}) => {
  const { school } = usePathwrightContext()
  if (!visibleResources || !privateResources) return null
  const hasResources =
    visibleResources.edges.length > 0 || privateResources.edges.length > 0
  return (
    <PlaceLauncher
      name={school.platform_version >= 2.8 ? "Store" : "Library"}
      icon="grid-large"
      color="#7ED321"
      to={school.platform_version >= 2.8 ? "/store/" : "/library/"}
      action={
        school.platform_version >= 2.8 ? "Explore store" : "Explore library"
      }
      onLaunch={onLaunch}
      isBlank={!hasResources}
      blankImage="library"
      blankDescription={`Organize your discoverable courses from ${school.name}.`}
      footer={
        hasResources &&
        resourceStats && (
          <p>
            {resourceStats.public} discoverable • {resourceStats.private}{" "}
            private
          </p>
        )
      }
    >
      {hasResources && (
        <LibraryPreview
          visibleResources={visibleResources.edges
            .map((edge) => edge.node)
            .reverse()}
          privateResources={privateResources.edges
            .map((edge) => edge.node)
            .reverse()}
        />
      )}
    </PlaceLauncher>
  )
}

LibraryPlace.displayName = "LibraryPlace"

LibraryPlace.fragments = {
  resourceStats: ResourceStatsFragmentDoc,
  visibleResources: VisibleResourcesFragmentDoc,
  privateResources: PrivateResourcesFragmentDoc
}

export default LibraryPlace
